<template>
  <!-- Altura reservada: mensagem nova não pode empurrar o tabuleiro que o jogador já leu.
       `aria-live` porque quem usa leitor de tela precisa saber que errou. -->
  <div class="status" aria-live="polite">
    <div v-if="message" class="msg" :class="`tone-${message.tone}`">
      <AppIcon :name="message.icon" size="sm" />
      {{ message.text }}
    </div>
  </div>
</template>

<script>
import AppIcon from '../ui/AppIcon.vue';

export default {
  name: 'StatusLine',
  components: { AppIcon },
  props: { message: { type: Object, default: null } },
};
</script>

<style scoped>
.status {
  flex: none;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 0 12px;
}

.msg {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 9px 14px;
  border-radius: var(--r-chip);
  font: 600 12px/1.3 var(--f-body);
  animation: msg-in 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes msg-in {
  from { opacity: 0; transform: translateY(6px) scale(0.94); }
  to { opacity: 1; transform: none; }
}

/* Diretiva 02: verde é o que deu certo, âmbar é aviso que não custou nada, vermelho é o
   que custou. */
.tone-good { background: var(--ok-veil); border: 1px solid var(--ok-line); color: var(--ok); }
.tone-warn { background: var(--amber-veil); border: 1px solid var(--amber-line); color: var(--amber); }
.tone-bad { background: var(--error-veil); border: 1px solid var(--error-line); color: var(--error-light); }
.tone-mute { background: var(--veil-2); border: 1px solid var(--line); color: var(--text-3); }
</style>
